var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-q-red w-screen h-screen flex items-center justify-center",attrs:{"id":"app"}},[_c('div',{staticClass:"text-white font-highlights uppercase font-bold leading-none"},[_c('ClockCountdown',{attrs:{"end":new Date(2020,11, 17, 10, 43)},on:{"finished":function($event){return _vm.countdownFinished()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }